import styles from "./style.module.scss";
import Photo1 from "src/assets/photo-gallery/photo1.jpg";
import Photo2 from "src/assets/photo-gallery/photo2.jpg";
import Photo3 from "src/assets/photo-gallery/photo3.jpg";
import Photo4 from "src/assets/photo-gallery/photo4.jpg";
import Photo5 from "src/assets/photo-gallery/photo5.jpg";
import Photo6 from "src/assets/photo-gallery/photo6.jpg";
import Photo7 from "src/assets/photo-gallery/photo7.jpg";
import Photo8 from "src/assets/photo-gallery/photo8.jpg";
import Photo9 from "src/assets/photo-gallery/photo9.jpg";

export const PhotoSection = () => {
  return (
    <section className={styles.container}>
      <div className={styles.innerBox}>
        <h2>
          Photo gallery<span>-フォトギャラリー-</span>
        </h2>
      </div>

      <div className={styles.imageBox}>
        <img src={Photo1} alt="Photo1" className={styles.full} />
        <div className={styles.flexBox}>
          <img src={Photo2} alt="Photo2" className={styles.small} />
          <img src={Photo3} alt="Photo3" className={styles.large} />
        </div>
        <div className={styles.flexBox}>
          <img src={Photo4} alt="Photo4" className={styles.large} />
          <img src={Photo5} alt="Photo5" className={styles.small} />
        </div>
        <div className={styles.flexBox}>
          <img src={Photo6} alt="Photo6" className={styles.small} />
          <img src={Photo7} alt="Photo7" className={styles.large} />
        </div>
        <div className={styles.flexBox}>
          <img src={Photo8} alt="Photo8" className={styles.large} />
          <img src={Photo9} alt="Photo9" className={styles.small} />
        </div>
      </div>
    </section>
  );
};
